import styled from 'styled-components';

const Text = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular}
  white-space: pre-line;
  align-self: center;
  line-height: 20px;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(12)};
`;

export default Text;
